<template lang="pug">
  .managerDetail.container
    h3.managerDetail__title.col-md-12 檢視使用者
    EditManagerInputsTable.managerDetail__inputsTable(
      :class="'col-md-6'"
      @openUpdatePasswordModal="openUpdatePasswordModal")
    AblilityGroupTable.managerDetail__abilityGroupTable(
      :class="'col-md-6'")
    UpdatePasswordModal(v-if="showUpdatePasswordModal"
      @hideUpdatePasswordModal="hideUpdatePasswordModal")
</template>
<script>
import EditManagerInputsTable from '@/pages/manager/EditManagerInputsTable'
import AblilityGroupTable from '@/pages/manager/AblilityGroupTable'
import UpdatePasswordModal from '@/components/common/modal/UpdatePasswordModal'

export default {
  name: 'ManagerDetail',
  data() {
    return {
      showUpdatePasswordModal: false,
    }
  },
  methods: {
    hideUpdatePasswordModal() {
      this.showUpdatePasswordModal = false
    },
    openUpdatePasswordModal() {
      this.showUpdatePasswordModal = true
    },
  },
  components: {
    AblilityGroupTable,
    EditManagerInputsTable,
    UpdatePasswordModal,
  },
}
</script>
<style lang="scss" scoped>
.managerDetail {
  padding: 0 20px;
  background: #f7f7f7;

  &__title {
    padding-top: 10px;
    padding-bottom: 20px;
    margin: 0;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/ManagerDetailNew.vue